import {ArtfactKind, EnvironmentKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';
import {HttpHook} from '../http/http.hook';

@HookClass('perosn')
export class PersonHook extends BaseHook {

    @Hook('034aeabb-d168-46c0-ba73-5cb0887593af')
    public checkIfPersonExists(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://api.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://api.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/1e036dd2-5a8a-4631-98cb-acf1a94788a9`,
                                params: {},
                                headers: {
                                    'nick-system': '774bfaa5-fab2-4528-80f1-293afb8eb71d'
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('95d7e5d9-1d74-4048-9ddd-0dea613d518c')
    public createPersonBySystemId(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://api.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://api.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/19d2c4d0-141e-450f-a72f-5010892c03a0`,
                                params: {},
                                headers: {
                                    'nick-system': '774bfaa5-fab2-4528-80f1-293afb8eb71d'
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('429a4bf7-de06-435f-befa-cdf171a9f065')
    public getPersonByDocumentAndSystemId(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://api.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://api.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/b780d11e-568f-40f1-aba5-e182b97e2b39`,
                                params: {},
                                headers: {
                                    'nick-system': '774bfaa5-fab2-4528-80f1-293afb8eb71d'
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }
}
